<template lang="html">
  <div class="product-detail">
    <!--保证接口已返回值 再渲染页面-->
    <!-- <template v-if="isNew"> -->
    <NewProduct v-if="product && product.spuId"> </NewProduct>
    <empty v-else v-show="!firstFetch" text="没有找到该商品"></empty>
    <!-- </template> -->

    <!-- <div class="product-detail" v-else> -->
    <!-- 产后恢复 -->
    <!-- <recoveryComponent
        v-if="isRebuilding"
        :product="product"
    ></recoveryComponent>-->
    <!-- 公共的 -->
    <!-- <commonComponent v-else-if="product && product.spuId"></commonComponent>
      <empty v-else v-show="!firstFetch" text="没有找到该商品"></empty>
    </div>-->
  </div>
</template>

<script>
import './style.scss' // no scoped

import { mapState, mapMutations } from 'vuex'
import queryString from 'query-string'
import dayjs from 'dayjs'
import {
  getSelectterm,
  isEmptyObject,
  isHZWAPP,
  isNonEmptyArray,
  isRKHYAPP
} from '@/utils'
import B_GOODS from '@/business/goods'
import { queryAllSaleNumBySpuParentId } from '@/service/product'
import { closeWindow, isApp } from 'kwsdk'
import empty from '@/components/common/empty'
import ShareComponent from '../groupBuy/shareComponent'
import NewProduct from './product-detail'
import { getPageTitle } from './components/product/product-intro/config'

import {
  dispatchMixPromotion,
  setLiveCookie,
  setTitle
} from './new/product.bus'
import { getLocation } from '@/plugins/location'
const replaceHref = () => location.replace(location.origin + location.pathname)
import mixProm from '@/mixin/mixProm'

export default {
  mixins: [mixProm],
  PAGE_ID: '288990',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.commit('changeView', '')
      vm.$store.commit('hideActionSheet')
    })
    next()
  },
  data() {
    return {
      spuId: this.$route.params.spuId || 0,
      skuId: 0,
      ruleType: 1,
      ruleId: '',
      firstFetch: true,
      skuList: [],
      empid: '', // id为小写，兼容querystring的数据
      businessId: '', //商家id
      level4CategoryId: '',
      skuIdForMixPromInfo: 0,
      isNew: true,
      citycode: '',
      loaded: false // canvas绘制完成状态
    }
  },

  async created() {
    this.$$loading(true)
    setTitle(this)
    setLiveCookie(this)
    try {
      await this.initProductParams()
      await this.initProductDetail()
      this.getCityCode()
      this.generalPage()

      // 如果某商品规格删除后，用户打开该链接后，页面展示不正确，新增兜底策略
      // 拼错spuId 返回空白页
      if (isEmptyObject(this.product) || !isNonEmptyArray(this.skuList)) {
        if (!this.isRedirect) {
          this.firstFetch = false
          this.$$loading(false)
        }
        return
      }
      this.$$loading(false)
      this.firstFetch = false
      this.initSelectedSku()
      this.initSelectedPayMethod()
      this.getSkuIdForMixPromInfo()
      await this.getSaleNum()
      await this.getOtherServices()
      await this.$store.dispatch('getMainConfig')
      this.track()
    } catch (e) {
      console.error('error is  ', e)
      this.$$error(e, this)
    }
    /*this.$$newTrackView({
      bizType: '127',
      pageLevelId: '121013031',
      pageParam: {
        popid: this.product && this.product.businessId,
        spuid: this.product && this.product.spuId,
        categoryid: this.product && this.product.level4CategoryId
      }
    }) */
  },
  async mounted() {
    try {
      window.kwapp.allowRefreshOrShare(false, false)
    } catch (e) {
      if (window.kwapp && window.kwapp.onReady) {
        window.kwapp.onReady(() => {
          window.kwapp.allowRefreshOrShare(false, false)
        })
      }
      console.error('errr is  ', e)
      this.$$error(e, this)
    }
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual' //改为manual之后，就不会记录滚动位置
    }
  },
  methods: {
    ...mapMutations([
      'showActionSheet',
      'changeView',
      'setActionHeader',
      'setSelectedSku',
      'setSelectedPayMethod'
    ]),
    async track() {
      const seletcterm = await getSelectterm()
      if (this.product) {
        if (this.$$isHZWApp()) {
          this.$$newTrackView(this.getTrackParams(this.citycode, seletcterm))
        } else {
          getLocation()
            .then(({ citycode }) => {
              this.$$newTrackView(this.getTrackParams(citycode, seletcterm))
            })
            .catch(e => {
              this.$$newTrackView(
                this.getTrackParams(this.citycode, seletcterm)
              )
            })
        }
      }
    },
    getTrackParams(citycode, seletcterm) {
      return {
        bizType: '127',
        pageLevelId: '121013031',
        pageParam: {
          citycode,
          popid: this.product && this.product.businessId,
          spuid: this.product && this.product.spuId,
          categoryid: this.product && this.product.level4CategoryId,
          biztype: this.product.selfPurchase ? '直采' : '联营',
          seletcterm,
          adinfo: this.$$cookie('ad-planid') || ''
        }
      }
    },
    initSelectedSku() {
      let _selectedSku = {}
      if (this.skuId) {
        const arr = this.skuList.filter(sku => sku.skuId === this.skuId - 0)
        if (isNonEmptyArray(arr)) {
          _selectedSku = arr[0]
        } else {
          // 商品规格未匹配成功
          replaceHref()
        }
      } else if (this.skuList.length === 1) {
        _selectedSku = this.skuList[0]
        this.skuId = _selectedSku.skuId
      }
      this.setSelectedSku(_selectedSku)
    },
    initSelectedPayMethod() {
      if (this.isBlessScorable) {
        this.setSelectedPayMethod('point')
      } else {
        this.setSelectedPayMethod('money')
      }
    },
    /**
     * 描述  促销活动已结束，提示并跳转至普通商品页面。底逻辑
     * @date 2021-02-23
     * @returns {any}
     */
    generalPage() {
      const rule = this.product.ruleDetail
      if (rule && rule.ruleId) {
        const nowTime = new Date()
        const endTime = dayjs(rule.endTimeStr)
        if (endTime.isBefore(nowTime)) {
          this.$$toast('当前活动已结束')
          setTimeout(replaceHref, 1e3)
          return
        }
      }
    },
    /**
     * 描述 商品详情
     * @date 2021-02-23
     * @returns {any}
     */
    async initProductDetail() {
      const params = {
        spuId: this.spuId || 0,
        skuId: this.skuId || '',
        ruleType: this.ruleType || 1,
        ruleId: this.ruleId || '',
        uid: this.$$cookie('uid') || '',
        skey: this.$$cookie('skey') || '',
        appSource: this.$$getDevice() || ''
      }
      console.log('params :>> ', params)
      const query = queryString.stringify(params || {})
      await this.$store.dispatch('getProductDetail', query)
      this.skuList = this.product.cmmdtySpecs || []
      this.businessId = this.getRealBusinessId()
      this.level4CategoryId = this.product.level4CategoryId
      this.$$title(getPageTitle(this.product.spuType, this.level4CategoryId))
    },
    /**
     * 描述 初始化获取商详的全部参数，并且绑定到data里
     * @date 2021-02-23
     * @returns {any}
     */
    async initProductParams() {
      const vueQuery = this.$route.query || {}
      const { skuId = '', ruleType = 1, ruleId = '', empid = '' } = vueQuery
      const spuId = await this.initSpuId(skuId, ruleType, ruleId, empid)
      Object.assign(this, { skuId, ruleType, ruleId, empid })
    },
    /**
     * 描述  老逻辑   skuId: this.spuId,
     * @date 2021-02-23
     * @param {any} skuId
     * @param {any} ruleType
     * @param {any} ruleId
     * @param {any} empid
     * @returns {any}
     */
    async initSpuId(skuId, ruleType, ruleId, empid) {
      let _spuid = this.$route.params.spuId || ''
      if (!(_spuid && skuId && ruleType && ruleId)) {
        const json = await this.$store.dispatch('getNewSpuBySku', {
          skuId: _spuid,
          empId: empid
        })
        if (json.data && json.data.spuId) {
          _spuid = json.data.spuId || ''
        }
      }
      return _spuid
    },

    /**
     * 描述 多规格的时候选择售卖价最低的skuid用于获取组合优惠
     * @date 2021-02-23
     * @returns {any}
     */
    getSkuIdForMixPromInfo() {
      const _t = [...this.skuList].sort((a, b) => {
        return a.price - b.price
      })
      this.skuIdForMixPromInfo = this.skuid || _t[0].skuId
    },
    getOtherServices() {
      //获取本店其他服务
      this.$store.dispatch('getOtherServices', {
        spuId: this.spuId,
        businessId: this.businessId,
        cityId: this.citycode
      })
    },
    /**
     * 只有定制SKU商品才需要重新计算销量
     */
    async getSaleNum() {
      const { source, saleAttribute } = this.product
      if (B_GOODS.isSKUGoods(source, saleAttribute)) {
        let count = await queryAllSaleNumBySpuParentId(this.spuId)
        this.product.saleNum = count
      }
    },

    getCityCode() {
      const city = (this.$$cookie('city_service') || '').split('_')[0]
      if (city) {
        this.citycode = city
      } else {
        this.citycode = this.$$cookie('citycode') || '320100' //默认南京
      }
    },
    getRealBusinessId() {
      const { businessId, cmmdtyUseBusiness = [] } = this.product
      cmmdtyUseBusiness.forEach(element => {
        if (businessId === element.businessId) {
          return businessId
        }
      })
      if (cmmdtyUseBusiness.length > 0) return cmmdtyUseBusiness[0].businessId
    }
  },
  watch: {
    selectedSku() {
      this.skuId = this.selectedSku.skuId
      dispatchMixPromotion(this)
    }
  },
  computed: {
    ...mapState('promotionInfo', {
      mixPromotionInfo: state => state.promotionInfo
    }),
    ...mapState([
      'product',
      'isRedirect',
      'viewName',
      'comments',
      'commentCount',
      'selectedWorker',
      'selectedAddress',
      'selectedTime',
      'locationInfo',
      'selectedSku',
      'isMinProgram'
    ]),
    price() {
      // 聚合各方价格显示。秒杀时，显示promPrice，其他时候走之前逻辑
      if (this.hasPromotion) {
        return this.product.ruleDetail.promPrice / 100
      } else {
        if (this.selectedSku && this.selectedSku.skuId) {
          return this.selectedSku.price / 100
        } else {
          if (this.product.maxPrice === 0 && this.product.minPrice === 0) {
            return this.product.minPrice / 100
          }
          if (this.product.minPrice === this.product.maxPrice) {
            return this.product.minPrice / 100
          } else {
            return this.product.minPrice / 100
          }
        }
      }
    },
    hasPromotion() {
      // 促销未开始和已结束，没有促销
      const rule = this.product.ruleDetail
      if (rule && rule.ruleId) {
        const nowTime = new Date().getTime()
        const startTime = new Date(rule.startTimeStr)
        const endTime = new Date(rule.endTimeStr)
        if (startTime > nowTime || endTime < nowTime) {
          return false
        } else {
          return true
        }
      }
      return false
    },
    productImage() {
      return this.product.cmmdtyImages
    }
  },
  components: {
    empty,
    // recoveryComponent,
    // commonComponent,
    ShareComponent,
    NewProduct
  },
  provide() {
    return {
      /* 更多评价事件埋点参数 */
      allCommentTrackParams: {
        bizType: '127',
        pageLevelId: '121013031',
        clickId: '200014'
      },
      /* 商家电话事件埋点参数 */
      busiTelTrackParams: {
        bizType: '127',
        pageLevelId: '121013031',
        clickId: '200005'
      },
      /* 点击头图事件埋点参数 */
      cmmdImgTrackParams: {
        bizType: '127',
        pageLevelId: '121013031',
        clickId: '200001'
      },
      /* 其他商品事件埋点参数 */
      otherProductTrackParams: {
        bizType: '127',
        pageLevelId: '121013031',
        clickId: '200015'
      },
      /* 门店地址事件埋点参数 */
      busiMapTrackParams: {
        bizType: '127',
        pageLevelId: '121013031',
        clickId: '200006'
      },
      /* 查看全部门店事件埋点参数 */
      allStoreTrackParams: {
        bizType: '127',
        pageLevelId: '121013031',
        clickId: '200003'
      },
      /* 立即购买事件埋点参数 */
      buyTrackParams: {
        bizType: '127',
        pageLevelId: '121013031',
        clickId: '200016'
      },
      /* 门店信息事件埋点参数 */
      storeInfoTrackParams: {
        bizType: '127',
        pageLevelId: '121013031',
        clickId: '200004'
      },
      /* 产康福袋埋点参数 */
      luckBagTrackParams: {
        bizType: '127',
        pageLevelId: '121013031',
        clickId: '200017'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.product-detail {
  min-height: 100%;
  padding-bottom: rem(119px);
}
</style>
<style lang="scss" scoped src="./style.scss"></style>
